module.exports = __webpack_public_path__ + "static/media/logo-6.c3fe04b2.jpg";